import { AfterViewInit, ElementRef } from '@angular/core';
import { SOURCE_MAPPINGS } from '../models/source.model';
import { LinkifyPipe } from '../linkify/linkify.pipe';
var DataItemComponent = /** @class */ (function () {
    function DataItemComponent(_linkifyPipe) {
        this._linkifyPipe = _linkifyPipe;
        this.compact = false;
        this.showLabel = false;
        this.linkify = false;
        this.flex = false;
        this._cls = true;
    }
    Object.defineProperty(DataItemComponent.prototype, "_clsCompact", {
        get: function () {
            return this.compact;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataItemComponent.prototype, "sourceValid", {
        get: function () {
            return SOURCE_MAPPINGS.has(this.source);
        },
        enumerable: true,
        configurable: true
    });
    DataItemComponent.prototype.ngAfterViewInit = function () {
        if (this.linkify) {
            var el = this.content.nativeElement;
            el.innerHTML = this._linkifyPipe.transform(el.innerHTML);
        }
    };
    return DataItemComponent;
}());
export { DataItemComponent };
